export default __webpack_public_path__ + "static/media/Slider-2.f32d553d.jpg";